import React from 'react';
import { Play, ArrowRight, CheckCircle } from 'lucide-react';
import { Link } from 'react-router-dom';

const Hero = () => {
  return (
    <section className="relative min-h-screen flex items-center bg-gradient-to-br from-blue-900 to-purple-900 text-white overflow-hidden">
      <div className="absolute inset-0 bg-grid-pattern opacity-10"></div>
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 lg:py-32">
        <div className="lg:grid lg:grid-cols-12 lg:gap-8 items-center">
          <div className="lg:col-span-6">
            <div className="text-center lg:text-left px-4 lg:px-0">
              <div className="inline-flex items-center px-4 py-2 rounded-full bg-white/20 backdrop-blur-sm text-blue-100 text-sm font-medium mb-8">
                <span className="mr-2">🎉</span>
                Trusted by 50,000+ teams worldwide
              </div>
              
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-8">
                All-in-One
                <span className="block bg-gradient-to-r from-blue-300 to-purple-300 bg-clip-text text-transparent">
                  Management Platform
                </span>
              </h1>
              
              <p className="text-lg md:text-xl text-blue-100 mb-12 max-w-2xl mx-auto lg:mx-0 leading-relaxed">
                Streamline your entire business with our comprehensive platform. Manage projects, tasks, assets, HR, and everything in between from one powerful dashboard.
              </p>
              
              <div className="flex flex-col sm:flex-row gap-6 justify-center lg:justify-start mb-16">
                <Link to="/registration" className="group bg-white text-blue-900 px-8 py-4 rounded-lg hover:bg-blue-50 transition-all duration-200 transform hover:scale-105 font-semibold text-lg shadow-lg">
                  Start Free Trial
                  <ArrowRight className="inline-block ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform duration-200" />
                </Link>
                <button className="group flex items-center justify-center px-8 py-4 border-2 border-white/30 rounded-lg hover:border-white hover:bg-white/10 transition-all duration-200 font-semibold text-lg">
                  <Play className="mr-2 h-5 w-5 group-hover:scale-110 transition-transform duration-200" />
                  Watch Demo
                </button>
              </div>
              
              <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start space-y-4 sm:space-y-0 sm:space-x-8 text-blue-200 text-base">
                <div className="flex items-center">
                  <CheckCircle className="h-5 w-5 text-green-500 mr-2" />
                  No credit card required
                </div>
                <div className="flex items-center">
                  <CheckCircle className="h-5 w-5 text-green-500 mr-2" />
                  14-day free trial
                </div>
                <div className="flex items-center">
                  <CheckCircle className="h-5 w-5 text-green-500 mr-2" />
                  Cancel anytime
                </div>
              </div>
            </div>
          </div>
          
          <div className="mt-16 lg:mt-0 lg:col-span-6">
            <div className="relative px-4 lg:px-0">
              <div className="absolute -inset-4 bg-gradient-to-r from-blue-300 to-purple-300 rounded-lg blur-xl opacity-20 animate-pulse"></div>
              <div className="relative bg-white rounded-lg shadow-2xl p-10 transform hover:scale-105 transition-transform duration-300">
                <div className="mb-8">
                  <div className="flex items-center justify-between mb-4">
                    <div className="flex space-x-2">
                      <div className="w-3 h-3 bg-red-400 rounded-full"></div>
                      <div className="w-3 h-3 bg-yellow-400 rounded-full"></div>
                      <div className="w-3 h-3 bg-green-400 rounded-full"></div>
                    </div>
                    <div className="text-sm text-gray-500">work.olecons.com Dashboard</div>
                  </div>
                  <div className="space-y-6">
                    <div className="h-4 bg-gradient-to-r from-blue-200 to-purple-200 rounded-full"></div>
                    <div className="grid grid-cols-3 gap-6">
                      <div className="h-20 bg-blue-100 rounded-lg"></div>
                      <div className="h-20 bg-purple-100 rounded-lg"></div>
                      <div className="h-20 bg-green-100 rounded-lg"></div>
                    </div>
                    <div className="h-40 bg-gray-100 rounded-lg"></div>
                    <div className="flex space-x-6">
                      <div className="h-10 bg-blue-200 rounded flex-1"></div>
                      <div className="h-10 bg-purple-200 rounded flex-1"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;